<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :draggable="draggable"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :checkStrictly="false"
                        @onDbClick="onDbClickTree"
                        @onClick="onDbClickTree"
                        :checkNodes="checkNodes"
                        :showBox="false"
                        :dragLevel="true"
                        :isPaging="true"
                        :parentOrgIds="parentOrgId"
                        :orgIds="orgIds"
                        :sCodes="sCodes"
                        :orgTypeIds="orgTypeIds"
                        :defaultProps="defaultProps"
                        :nodeKey="nodeKey"
                        :isDistributed="false"
                        :interfaceName="interfaceName"
                        :params="params"
                        @nodeDrop="nodeDrop"
                        ref="TdTree"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-form :inline="true">
                            <el-row style="margin-top:10px;">
                                <el-col :span="10001">
                                    <div class="userModuleInfoLogo"></div>
                                </el-col>
                                <el-col :span="10023" style="margin-left:10px;">
                                    <div style="font-weight:bold;">{{ $t('common.BASE_INFO') }}</div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-bottom:20px;margin-top:10px;">
                                <el-form-item :label="$t('common.NAME')">
                                    <td-input width="180" v-model="baseInfo.name" :disabled="true" data-toggle="tooltip"> </td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.TYPE')" style="padding-right:10px;">
                                    <td-input width="180" v-model="baseInfo.type" :disabled="true"></td-input>
                                </el-form-item>
                                <el-form-item style="padding-left:0px;margin-top:0px;">
                                    <td-button type="button" size="medium" :permissions="permissionsEdit" @click="btnEdit" :disabled="baseInfo.name === '' || baseInfo.name === null">{{
                                        $t('pgCommon.EDIT')
                                    }}</td-button>
                                    <td-button type="button" size="medium" :permissions="permissionsDel" @click="btnDelete" :disabled="baseInfo.name === '' || baseInfo.name === null">{{
                                        $t('pgCommon.DELETE')
                                    }}</td-button>
                                    <td-button type="button" size="medium" :permissions="permissionsImport" @click="btnImport">{{ $t('pgCommon.IMPORT') }}</td-button>
                                    <td-button type="button" size="medium" :loading="exportLoadding" :permissions="permissionsExport" @click="btnExport">{{ $t('pgCommon.EXPORT') }}</td-button>
                                </el-form-item>
                            </el-row>
                        </el-form>
                    </div>
                </td-permission>
            </el-header>
            <el-main style="padding-bottom: 0px;">
                <td-permission :permissions="permissionsView" style="width:100%;">
                    <div slot="havePermission">
                        <el-tabs v-model="selectTabsValue" type="card" @tab-click="onClickTab">
                            <el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
                                <div :style="{ display: isPaneDisplay }">
                                    <el-row class="marginBottom10" style="margin-top:15px;">
                                        <el-col :span="9">
                                            <td-button type="primary" size="medium" :permissions="permissionsAdd" @click="onClickAdd(index)">{{ $t('pgCommon.ADD') }}</td-button>
                                            <td-button size="medium" :permissions="permissionsDel" @click="onClickBatchDelete(index)">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
                                        </el-col>
                                    </el-row>
                                    <el-row style="height:200px">
                                        <td-table
                                        :columns="columns[index]"
                                        :rowKey="id"
                                        :dataSource="tableData[index]"
                                        :pageSize="pageSize"
                                        :currentPage="currentPages[index]"
                                        :total="totals[index]"
                                        :hasLoading="loadings[selectTabsValue]"
                                        :ref="'orgTable' + index"
                                        @handleSizeChange="handleSizeChange"
                                        @currentChange="handleCurrentChange"
                                    >
                                    </td-table>
                                    </el-row>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <component
                            v-bind:is="currentTabComponent"
                            ref="modifyOrg"
                            @submit="submit"
                            @change="change"
                            :tableData="customTabledata"
                            :pageSize="customPageSize"
                            :currentPage="customPage"
                            :total="customTotal"
                            :treeNode="nowTreeItem"
                            :typeOptions="typeOptions"
                            @handlePageChange="handlePageChange"
                            @deleteOrg="deleteOrg"
                            @editOrg="editOrg"
                            @addOrg="addOrg"
                        >
                        </component>
                    </div>
                </td-permission>
                <!-- 添加组织窗口-->
                <td-addOrg
                    v-if="addOrgAvailable"
                    :title="dialogTitle"
                    :isAddData="isAddData"
                    :addPaneName="addPaneName"
                    :tabOptions="tabOptions"
                    :extendGroupFlg="extendGroupFlg"
                    :selectType="selectType"
                    :editItem="editItem"
                    :addOrgAvailable="addOrgAvailable"
                    :isAllowOrgIdDictDisabled="isAllowOrgIdDictDisabled"
                    @submit="submit"
                    @addOrgDialogClose="addOrgDialogClose"
                    @reciveOrgInfoFromDialog="reciveOrgInfoFromDialog"
                    ref="addOrg"
                >
                </td-addOrg>
                <!-- 修改组织窗口-->
                <td-modifyOrg
                    v-if="modifyOrgAvailable"
                    :title="dialogTitle"
                    :isAddData="isAddData"
                    :modifyPaneName="modifyPaneName"
                    :tabOptions="tabOptions"
                    :extendGroupFlg="extendGroupFlg"
                    :editItem="editItem"
                    :modifyDialogWidth="modifyDialogWidth"
                    :modifyOrgAvailable="modifyOrgAvailable"
                    @submit="submit"
                    @modifyOrgDialogClose="modifyOrgDialogClose"
                    @reciveOrgInfoFromDialog="reciveOrgInfoFromDialog"
                    ref="modifyOrg"
                >
                </td-modifyOrg>
                <dialog-OrgImport
                    :title="importTitle"
                    v-if="isImportVisible"
                    :iDeviceTypes="iDeviceTypes"
                    :orgId="orgId"
                    :isImportVisible="isImportVisible"
                    @dlalogImportClose="importClose"
                    @submit="submit"
                ></dialog-OrgImport>
                <dialog-Message ref="dialogMsg" v-show="isMsgAvailable" :isMsgAvailable="isMsgAvailable" :title="msgTitle" @dlalogMsgClose="dlalogMsgClose"></dialog-Message>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import orgApi from './assets/api.js';
import dialogOrgImport from './orgComponents/dialogOrgImport.vue';
import dialogMessage from './orgComponents/dialogMessage.vue';
export default {
    components: {
        'dialog-OrgImport': dialogOrgImport,
        'dialog-Message': dialogMessage
    },

    created() {
        if (document.body.clientWidth >= 1920) {
            this.screenSpan = 4;
        } else if (document.body.clientWidth >= 1600) {
            this.screenSpan = 5;
        } else if (document.body.clientWidth >= 1440) {
            this.screenSpan = 6;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.modifyDialogWidth = 650 + newVal;
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    mounted() {
        // 是否有拖动排序权限
        let permissionStr = sessionStorage.getItem('stringPermissions');
        if (permissionStr != null && permissionStr != '' && permissionStr != undefined) {
            let permissionList = permissionStr.split(',');
            for (let i = 0; i < permissionList.length; i++) {
                if (permissionList[i] === 'org:sort') {
                    this.draggable = true;
                }
            }
        }
        this.initSortFiled();
        this.initOtherAttribute();
        this.setDefaultPage();
        this.checkAllowOrgIdDict();
    },

    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        },
        currentTabComponent: function() {
            // 判断是否显示自定义页面
            for (let i = 0; i < this.typeData.length; i++) {
                if (this.typeData[i].sPageName === this.selectTabsValue) {
                    this.isPaneDisplay = 'none';
                    return this.typeData[i].sPageName;
                }
            }
            this.isPaneDisplay = 'block';
            return this.paneName;
        }
    },

    data() {
        return {
            modifyDialogWidth: 650,
            permissionsView: ['org:view'],
            permissionsAdd: ['org:add'],
            permissionsDel: ['org:del'],
            permissionsEdit: ['org:edit'],
            permissionsImport: ['org:import'],
            permissionsExport: ['org:export'],
            lazyloading: true,
            exportLoadding: false,
            draggable: 'false',
            sortField: '',
            rootCodes: window.config.orgRootNodeInfo.rootCodes,
            rootIds: window.config.orgRootNodeInfo.rootIds,
            params: window.config.orgRootNodeInfo,
            checkNodes: [],
            typeContent: [{ sIcon: 'FIRST_CLASS' }, { sIcon: 'SECOND_CLASS' }],
            calInternal: false,
            editBaseOrg: false,
            isClick: true,
            tabIndex: 0,
            selectTabsValue: '0',
            editableTabsValue: '',
            selectType: '0',
            editableTabs: [],
            addPaneName: null,
            modifyPaneName: null,
            tabOptions: [],
            screenSpan: 6,
            parentOrgId: window.pgCommon.initOrgTreeParam.PARENTORGID,
            orgIds: window.pgCommon.initOrgTreeParam.ORGIDLIST,
            sCodes: window.pgCommon.initOrgTreeParam.SCODE,
            orgTypeIds: window.pgCommon.initOrgTreeParam.ORGTYPEIDS,
            dialogOrgVisible: false,
            isImportVisible: false,
            isMsgAvailable: false,
            addOrgAvailable: false,
            modifyOrgAvailable: false,
            editItem: {},
            dialogTitle: '',
            importTitle: '',
            msgTitle: '',
            orgId: '',
            isAddData: true,
            defaultProps: { label: 'caption', id: 'id', children: 'children', imgName: 'sIcon', parentId: 'parentId' },
            nodeKey: 'id',
            interfaceName: { query: '/OrgManagerController/findTree', search: '/OrgManagerController/find' },
            baseInfo: {
                name: '',
                type: ''
            },
            baseTabColums: [
                {
                    prop: 'orgName',
                    label: 'pgCommon.NAME'
                },
                {
                    prop: 'sCode',
                    label: 'pgCommon.ALARM_SERIAL_NUMBER'
                },
                {
                    prop: 'orgTypeName',
                    label: 'pgCommon.TYPE',
                    align: 'center'
                },
                {
                    prop: '',
                    label: 'pgCommon.OPERATE',
                    tableWidth: '250',
                    align: 'center',
                    render: (createElement, params) => {
                        let b1 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsEdit, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickEdit(params.row, false);
                                    }
                                }
                            },
                            this.$t('pgCommon.EDIT')
                        );
                        let isCanDelete = true;
                        if (!this.$util.isEmpty(params.row.sExtendInfo)) {
                            let nodes = JSON.parse(params.row.sExtendInfo.replace(/\\/g, ''));
                            let canDelete = nodes.private_isCanDelete;
                            if (canDelete === '0') {
                                isCanDelete = false;
                            }
                        }

                        let b2 = createElement(
                            'td-button',
                            {
                                props: { permissions: this.permissionsDel, type: 'text', size: 'mini' },
                                on: {
                                    click: () => {
                                        this.onClickDelete(params.row);
                                    }
                                }
                            },
                            this.$t('pgCommon.DELETE')
                        );

                        let list = [];
                        if (!this.$util.isEmpty(params.row.sDomainType) && params.row.sDomainType != '0') {
                            if (isCanDelete) {
                                list = [b2];
                            } else {
                                list = [];
                            }
                        } else {
                            if (isCanDelete) {
                                list = [b1, b2];
                            } else {
                                list = [];
                            }
                        }
                        return createElement('div', list);
                    }
                }
            ],
            columns: [],
            tableData: [],
            orgTypes: [],
            pageSize: 10,
            currentPages: [],
            totals: [],
            loadings: [],
            hasInitTree: false,
            isShowMainLogin: false,
            nowTreeItem: null,
            rootTreeItem: null,
            customTabledata: [],
            typeData: [],
            typeOptions: [],
            otherAttribute: [],
            isPaneDisplay: 'block',
            isAllowOrgIdDictDisabled: false
        };
    },
    methods: {
        // 初始化排序字段
        initSortFiled: function() {
            let content = {
                sTag: window.pangu.common.orgSortFiledTag
            };
            orgApi.getDictValuesByType(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('orgApi.getDictValuesByTag', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('orgApi.getDictValuesByTag', response.data.statusMessage);
                    return;
                }
                response.data.content.forEach(element => {
                    if (element.sCode === 'sortField') {
                        this.sortField = element.label;
                    }
                });
                // 排序字段不为空，并且有排序权限且按照名称排序
                if (this.sortField != '' && this.sortField === 'ORG.S_NAME' && this.draggable) {
                    this.draggable = false;
                }
            });
        },
        // 初始化附加字段
        initOtherAttribute: function() {
            let content = {
                sTag: window.pangu.common.orgColumTag
            };
            orgApi.getDictValuesByType(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('orgApi.getDictValuesByTag', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('orgApi.getDictValuesByTag', response.data.statusMessage);
                    return;
                }
                this.otherAttribute = response.data.content;
            });
        },

        // tab页点击事件
        onClickTab: function(item) {
            if (item.name === 'noDataTab') {
                return;
            }
            this.tabIndex = parseInt(item.index);
            this.currentPages[this.tabIndex] = 1;
            this.selectType = item.name;
            let queryVo = {
                needDetail: true,
                needPage: true,
                querySingleType: true,
                currentPage: 1,
                orgTypeIds: this.params.orgTypeIds,
                pageSize: this.pageSize
            };
            if (this.sortField === 'ORG.S_NAME') {
                queryVo.sortField = 'ORG.S_NAME';
            }
            if (this.nowTreeItem != null) {
                queryVo.parentOrgIds = this.nowTreeItem.id;
            }
            if (this.params.sParam !== null && this.params.sParam !== '' && this.params.sParam !== undefined) {
                queryVo.sParam = this.params.sParam;
            }
            for (let i = 0; i < this.typeData.length; i++) {
                if (this.typeData[i].type == item.name) {
                    queryVo.queryType = item.name;
                } else if (this.typeData[i].sPageName === item.name) {
                    this.selectType = item.name;
                    queryVo.queryType = this.typeData[i].type;
                }
            }
            this.queryData(queryVo, false);
        },

        // 树形双击事件
        onDbClickTree: function(item) {
            this.selectType = '0';
            this.tabIndex = 0;
            this.nowTreeItem = item;
            this.baseInfo.name = item.caption;
            this.baseInfo.type = item.typeName === '' ? item.sTypeName : item.typeName;
            let queryVo = this.getParam(item);
            if (this.rootTreeItem === null) {
                this.rootTreeItem = item;
            }
            //切换树形时，强制切换到第一页
            queryVo.currentPage = 1;
            this.currentPages[this.tabIndex] = 1;
            this.queryData(queryVo, false);
        },

        // 获取查询参数
        getParam: function(item) {
            let queryVo = {
                querySingleType: true,
                needDetail: true,
                needPage: true,
                currentPage: this.currentPages[this.tabIndex],
                orgTypeIds: this.params.orgTypeIds,
                pageSize: this.pageSize,
                parentOrgIds: ''
            };
            if (this.sortField === 'ORG.S_NAME') {
                queryVo.sortField = 'ORG.S_NAME';
            }
            if (item != null) {
                queryVo.parentOrgIds = item.id;
            }
            if (this.currentPage === []) {
                queryVo.currentPage = 1;
            }
            let type = 0;
            if (this.selectType !== 'noDataTab') {
                type = this.selectType;
            }
            if (this.params.sParam !== null && this.params.sParam !== '' && this.params.sParam !== undefined) {
                queryVo.sParam = this.params.sParam;
            }
            queryVo.queryType = type;
            return queryVo;
        },

        // 查询数据
        queryData: function(queryVo, isRefreshTabData) {
            this.loadings[this.tabIndex] = true;
            this.isShowMainLogin = true;
            let json = JSON.stringify(queryVo);
            orgApi.find(json, response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (response.data.content === null || response.data.content.length === 0) {
                            this.clearTab();
                            // 设置为默认页面
                            this.setDefaultPage();
                        } else {
                            this.typeData = response.data.content;
                            if (isRefreshTabData) {
                                for (let i = 0; i < response.data.content.length; i++) {
                                    let typeInfo = response.data.content[i];
                                    if (typeInfo.data != null && typeInfo.data.length > 0) {
                                        this.selectType = typeInfo.type + '';
                                        this.selectTabsValue = typeInfo.sPageName == null || typeInfo.sPageName == '' ? this.selectType : typeInfo.sPageName;
                                        this.refreshTabData(typeInfo);
                                    }
                                }
                            } else {
                                this.clearTab();
                                for (let i = 0; i < response.data.content.length; i++) {
                                    let typeInfo = response.data.content[i];
                                    this.createTab(typeInfo);
                                    if (typeInfo.data != null && typeInfo.data.length > 0) {
                                        this.selectType = typeInfo.type + '';
                                        this.selectTabsValue = typeInfo.sPageName == null || typeInfo.sPageName == '' ? this.selectType : typeInfo.sPageName;
                                    }
                                }
                            }
                        }
                    } else {
                        this.clearTab();
                        // 设置为默认页面
                        this.setDefaultPage();
                        this.loadings[this.selectTabsValue] = false; // 关闭遮罩层
                    }
                } else {
                    this.clearTab();
                    this.setDefaultPage();
                    this.$message({ type: 'info', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                    this.$log.error('/OrgManagerController/find', response);
                    this.loadings[this.selectTabsValue] = false; // 关闭遮罩层
                }
                this.isShowMainLogin = false;
            });
        },

        // 检测Tabs是否包含该类型对应的Tab页
        checkIsContain(typeInfo) {
            let contain = false;
            for (let i = 0; i < this.editableTabs.length; i++) {
                if (this.editableTabs[i].name === typeInfo.type + '') {
                    contain = true;
                }
            }
            return contain;
        },

        // 控制每页条数变化
        handleSizeChange(val) {
            let param = this.getParam(this.nowTreeItem);
            this.pageSize = val;
            param.pageSize = val;
            this.queryData(param, true);
        },

        // 控制页数变化
        handleCurrentChange(val) {
            let param = this.getParam(this.nowTreeItem);
            param.currentPage = val;
            this.currentPages[this.tabIndex] = val;
            this.queryData(param, true);
        },

        // 分页信息发生变化的回调函数
        handlePageChange(pageSize, currentPage) {
            this.pageSize = pageSize;
            let param = this.getParam(this.nowTreeItem);
            param.currentPage = currentPage;
            this.queryData(param, true);
        },

        //校验字典是否允许自定义组织ID
        checkAllowOrgIdDict(){
            let content = {
                sTag: 'ALLOW_ORGID_FLAG'
            };
            orgApi.getDictValuesByTag(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('hostApi.getDictValuesByTag', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('hostApi.getDictValuesByTag', response.data.statusMessage);
                    return;
                }
                response.data.content.forEach(element => {
                    if('1' == element.sCode){
                        this.isAllowOrgIdDictDisabled = true;
                    }
                });
            });
        },

        // 删除的回调函数
        deleteOrg(items, isBatchDelete) {
            if (isBatchDelete) {
                let orgIds = [];
                let deleteItem = [];
                for (let i = 0; i < items.length; i++) {
                    const element = items[i];
                    orgIds.push(element.orgId);
                    let item = { parentId: element.parentOrgId, id: element.orgId };
                    deleteItem.push(item);
                }
                if (orgIds.length === 0) {
                    this.$message({ type: 'warning', showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DELORG') });
                    return;
                }
                this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                    confirmButtonText: this.$t('pgCommon.SURE'),
                    cancelButtonText: this.$t('pgCommon.CANCEL'),
                    type: 'warning'
                })
                    .then(() => {
                        this.deleteOrgs(orgIds, deleteItem);
                    })
                    .catch(e => {
                        this.$log.error('TAB页批量删除', e);
                    });
            } else {
                this.onClickDelete(items);
            }
        },

        // 编辑的回调函数
        editOrg(items) {
            // 初始化类型下拉框
            orgApi.findOrgTypes('{}', response => {
                this.typeOptions = response.data.content;
                if (!this.$util.isEmpty(this.typeOptions)) {
                    for (let i = 0; i < this.typeOptions.length; i++) {
                        if (this.typeOptions[i].id == items.iType) {
                            this.extendGroupFlg = this.typeOptions[i].sGroupFlg;
                            this.modifyPaneName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        }
                        let typeInfo = this.typeOptions[i];
                        typeInfo.sDlgPageName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        this.tabOptions.push(typeInfo);
                    }
                }
                this.isAddData = false;
                this.editItem = items;
                this.dialogTitle = this.$t('pgCommon.EDIT_ORG');
                this.modifyOrgAvailable = true;
            });
        },

        // 查询Tab页数据
        queryTabList: function() {
            let param = this.getParam(this.nowTreeItem);
            if (this.selectTabsValue != 'noDataTab') {
                param.currentPage = this.currentPages[this.tabIndex];
                param.pageSize = this.pageSize;
            }
            this.queryData(param, false);
        },

        // 批量删除方法
        deleteOrgs: function(orgIds, deleteItem) {
            let deleteInfo = {
                orgIds: orgIds
            };
            orgApi.deleteOrg(JSON.stringify(deleteInfo), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.$refs.TdTree.editTreeNode(deleteItem, 'delete', this.nowTreeItem);
                        if (orgIds[0] === this.nowTreeItem.orgId) {
                            this.onDbClickTree(this.rootTreeItem);
                        } else {
                            this.queryTabList();
                        }
                    } else {
                        this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                }
            });
        },

        // 创建Tab页
        createTab(typeInfo) {
            // 自定义页面
            if (!this.$util.isEmpty(typeInfo.sPageName)) {
                this.editableTabs.push({
                    title: typeInfo.typeName + '(' + this.$t('pgCommon.QUANTITY') + ':' + typeInfo.count + ')',
                    name: typeInfo.sPageName
                });
                this.customTabledata = typeInfo.data;
                this.customTotal = typeInfo.count;
            } else {
                // 使用默认页面
                // 生成卡片页
                let type = typeInfo.type + '';
                this.editableTabs.push({
                    title: typeInfo.typeName + '(' + this.$t('pgCommon.QUANTITY') + ':' + typeInfo.count + ')',
                    name: type
                });
                // 生成表头
                let cl = this.$util.clone(this.baseTabColums);
                let titles = typeInfo.titles;
                for (const key in titles) {
                    // 如果包含|^|realname，则为某个字段的真实名称列，tab中不显示此列的值
                    if (key.indexOf('|^|realname') > -1) {
                        continue;
                    }
                    //判断是否显示
                    let showFlag = true;
                    if (this.otherAttribute && this.otherAttribute.length > 0) {
                        for (var i = 0; i < this.otherAttribute.length; i++) {
                            let sCode = this.otherAttribute[i].sCode;
                            let sValue = this.otherAttribute[i].sValue;
                            let codeArr = sCode.split('.');
                            if (type == codeArr[0] && codeArr[1] == key && sValue == '0') {
                                showFlag = false;
                                break;
                            }
                        }
                    }
                    if (!showFlag) {
                        continue;
                    }
                    if (titles.hasOwnProperty(key)) {
                        const element = titles[key];
                        let colItem = {
                            prop: titles[key + '|^|realname'] ? key + '|^|realname' : key,
                            label: element,
                            align: 'center'
                        };
                        cl.splice(cl.length - 1, 0, colItem);
                    }
                }
                this.columns.push(cl);
                // 生成数据
                this.orgTypes.push({
                    orgTypeId: typeInfo.type,
                    orgTypeName: typeInfo.typeName
                });
                this.tableData.push(typeInfo.data);
                this.totals.push(typeInfo.count);
                this.loadings.push(false);
            }
        },

        // 刷新Tab页数据
        refreshTabData(typeInfo) {
            if (typeInfo.sPageName === null || typeInfo.sPageName === '') {
                this.tableData[this.tabIndex] = typeInfo.data;
                this.totals[this.tabIndex] = typeInfo.count;
                this.loadings[this.selectTabsValue] = false;
                this.loadings = this.$util.clone(this.loadings);
                this.editableTabs[this.tabIndex].title = typeInfo.typeName + '(' + this.$t('pgCommon.QUANTITY') + ':' + typeInfo.count + ')';
            } else {
                this.customTabledata = typeInfo.data;
                this.customTotal = typeInfo.count;
                this.customLoading = false;
                this.editableTabs[this.tabIndex].title = typeInfo.typeName + '(' + this.$t('pgCommon.QUANTITY') + ':' + typeInfo.count + ')';
            }
        },

        // 清空Tab页
        clearTab() {
            this.totals = [];
            this.loadings = [];
            this.columns = [];
            this.tableData = [];
            this.editableTabs = [];
            this.orgTypes = [];
        },

        // 设置无数据默认页
        setDefaultPage: function() {
            this.editableTabs.push({
                title: this.$t('pgCommon.NO_DATA'),
                name: 'noDataTab'
            });
            this.selectTabsValue = 'noDataTab';
            this.columns.push(this.$util.clone(this.baseTabColums));
            this.tableData.push([]);
            this.currentPages.push(1);
            this.loadings.push(false);
        },

        // 基本信息区域编辑
        btnEdit: function() {
            if (this.rootCodes != null && this.rootCodes.length > 0) {
                for (let i = 0; i < this.rootCodes.length; i++) {
                    if (this.nowTreeItem.id != null && this.nowTreeItem.sCode === this.rootCodes[i]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_EDIT_ROOT'), type: 'warning' });
                        return;
                    }
                }
            }
            if (this.rootIds != null && this.rootIds.length > 0) {
                for (let i = 0; i < this.rootIds.length; i++) {
                    if (this.nowTreeItem.id != null && this.nowTreeItem.id === this.rootIds[i]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_EDIT_ROOT'), type: 'warning' });
                        return;
                    }
                }
            }
            let isCanDelete = true;
            if (!this.$util.isEmpty(this.nowTreeItem.sExtendInfo)) {
                let nodes = JSON.parse(this.nowTreeItem.sExtendInfo.replace(/\\/g, ''));
                let canDelete = nodes.private_isCanDelete;
                if (canDelete === '0') {
                    isCanDelete = false;
                }
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_EDIT_THIS_NODE'), type: 'warning' });
                return;
            }
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            if (!this.$util.isEmpty(this.nowTreeItem.sDomainType) && this.nowTreeItem.sDomainType != '0') {
                this.$message({ showClose: true, message: this.$t('pgMessage.NOT_THIS_PLATFORM_DATA_CAN_NOT_EDIT'), type: 'warning' });
                return;
            }
            if (this.nowTreeItem !== null) {
                let queryParam = {
                    needDetail: true,
                    needPage: false,
                    querySingleType: true,
                    orgIdList: [this.nowTreeItem.id],
                    recursiveQuery: true
                };
                orgApi.find(JSON.stringify(queryParam), response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                        if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                            if (response.data.content.length > 0 && response.data.content[0].data.length > 0) {
                                this.onClickEdit(response.data.content[0].data[0], true);
                            }
                        } else {
                            this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                        }
                    } else {
                        this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                        this.$log.error('/OrgManagerController/findTree', response);
                    }
                });
            }
        },

        // 基本信息区域删除
        btnDelete: function() {
            if (this.rootCodes != null && this.rootCodes.length > 0) {
                for (let i = 0; i < this.rootCodes.length; i++) {
                    if (this.nowTreeItem.id != null && this.nowTreeItem.sCode === this.rootCodes[i]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_ROOT'), type: 'warning' });
                        return;
                    }
                }
            }
            if (this.rootIds != null && this.rootIds.length > 0) {
                for (let i = 0; i < this.rootIds.length; i++) {
                    if (this.nowTreeItem.id != null && this.nowTreeItem.id === this.rootIds[i]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_ROOT'), type: 'warning' });
                        return;
                    }
                }
            }
            let isCanDelete = true;
            if (!this.$util.isEmpty(this.nowTreeItem.sExtendInfo)) {
                let nodes = JSON.parse(this.nowTreeItem.sExtendInfo.replace(/\\/g, ''));
                let canDelete = nodes.private_isCanDelete;
                if (canDelete === '0') {
                    isCanDelete = false;
                }
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_THIS_NODE'), type: 'warning' });
                return;
            }
            if (this.nowTreeItem.id === this.rootTreeItem.orgId) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_ROOT'), type: 'warning' });
                return;
            }
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs([this.nowTreeItem.id], [{ parentId: this.nowTreeItem.parentId, id: this.nowTreeItem.id }]);
                    this.onDbClickTree(this.rootTreeItem);
                })
                .catch(e => {
                    this.$log.error('基本信息区域删除', e);
                });
        },

        // table操作编辑
        onClickEdit: function(row, isBaseEdit) {
            // 初始化类型下拉框
            orgApi.findOrgTypes('{}', response => {
                this.editBaseOrg = isBaseEdit;
                this.typeOptions = response.data.content;
                if (!this.$util.isEmpty(this.typeOptions)) {
                    for (let i = 0; i < this.typeOptions.length; i++) {
                        if (this.typeOptions[i].id == row.iType) {
                            this.extendGroupFlg = this.typeOptions[i].sGroupFlg;
                            this.modifyPaneName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        }
                        let typeInfo = this.typeOptions[i];
                        typeInfo.sDlgPageName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        this.tabOptions.push(typeInfo);
                    }
                }
                this.isAddData = false;
                this.editItem = row;
                this.dialogTitle = this.$t('pgCommon.EDIT_ORG');
                this.modifyOrgAvailable = true;
            });
        },

        // table操作删除
        onClickDelete: function(row) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs([row.orgId], [{ parentId: row.parentOrgId, id: row.id }]);
                })
                .catch(e => {
                    this.$log.error('table操作删除', e);
                });
        },

        // 添加回调
        addOrg: function() {
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            orgApi.findOrgTypes('{}', response => {
                this.typeOptions = response.data.content;
                if (!this.$util.isEmpty(this.typeOptions)) {
                    for (let i = 0; i < this.typeOptions.length; i++) {
                        if (this.typeOptions[i].id == this.selectType) {
                            this.extendGroupFlg = this.typeOptions[i].sGroupFlg;
                            this.addPaneName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        }
                        let typeInfo = this.typeOptions[i];
                        typeInfo.sDlgPageName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        this.tabOptions.push(typeInfo);
                    }
                }
                this.isAddData = true;
                this.dialogTitle = this.$t('pgCommon.ADD_ORG');
                this.editItem = {
                    orgTypeId: this.selectType,
                    parentOrgId: this.nowTreeItem.id,
                    parentOrgName: this.nowTreeItem.caption
                };
                this.addOrgAvailable = true;
            });
        },

        // TAB页添加
        onClickAdd: function(index) {
            if (this.nowTreeItem.noPermission) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_OPERATE_THIS_NODE'), type: 'warning' });
                return;
            }
            orgApi.findOrgTypes('{}', response => {
                this.typeOptions = response.data.content;
                if (!this.$util.isEmpty(this.typeOptions)) {
                    for (let i = 0; i < this.typeOptions.length; i++) {
                        if (this.typeOptions[i].id == this.selectType) {
                            this.extendGroupFlg = this.typeOptions[i].sGroupFlg;
                            this.addPaneName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        }
                        let typeInfo = this.typeOptions[i];
                        typeInfo.sDlgPageName = this.$util.isEmpty(this.typeOptions[i].sDlgPageName) ? 'TdOrgInfo' : this.typeOptions[i].sDlgPageName;
                        this.tabOptions.push(typeInfo);
                    }
                }
                this.isAddData = true;
                this.dialogTitle = this.$t('pgCommon.ADD_ORG');
                this.addOrgAvailable = true;
                this.editItem = {
                    orgTypeId: this.orgTypes.length === 0 ? null : this.orgTypes[index].orgTypeId,
                    orgTypeName: this.orgTypes.length === 0 ? '无类型' : this.orgTypes[index].orgTypeName,
                    parentOrgId: this.nowTreeItem.id,
                    parentOrgName: this.nowTreeItem.caption
                };
            });
        },

        // TAB页批量删除
        onClickBatchDelete: function(index) {
            let rows = this.$refs['orgTable' + index][0].getSelectAllRows();
            if (rows.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DELORG') });
                return;
            }
            let orgIds = [];
            let deleteItem = [];
            let isCanDelete = false;
            for (let i = 0; i < rows.length; i++) {
                const element = rows[i];
                if (this.$util.isEmpty(element.sExtendInfo)) {
                    isCanDelete = true;
                } else {
                    let nodes = JSON.parse(element.sExtendInfo.replace(/\\/g, ''));
                    let canDelete = nodes.private_isCanDelete;
                    if (canDelete != '0') {
                        isCanDelete = true;
                    } else {
                        continue;
                    }
                }
                orgIds.push(element.orgId);
                let item = { parentId: element.parentOrgId, id: element.orgId };
                deleteItem.push(item);
            }
            if (!isCanDelete) {
                this.$message({ showClose: true, message: this.$t('pgCommon.CAN_NOT_DELETE_THIS_NODE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS_EX'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.deleteOrgs(orgIds, deleteItem);
                })
                .catch(e => {
                    this.$log.error('TAB页批量删除', e);
                });
        },

        // 监听dialog，将数据回显到树形
        reciveOrgInfoFromDialog: function(data) {
            if (!this.isAddData) {
                this.$refs.TdTree.editTreeNode([{ parentId: data.sParentId, id: data.sOrgId }], 'modify', data.sName);
                if (this.editBaseOrg) {
                    this.baseInfo.name = data.sName;
                }
                this.queryTabList();
                return;
            }
            let val = {
                id: data.id,
                caption: data.sName,
                noPermission: false,
                typeId: data.iType,
                typeName: data.sTypeName,
                parentId: data.sParentId,
                sIcon: data.sIcon
            };
            // 添加根节点，树形操作参数处理
            let parentItem = [];
            let isTreeRootNode = false;
            // 判断当前选中节点是否是根节点
            if (this.rootIds != null && this.rootIds.length > 0) {
                for (let i = 0; i < this.rootIds.length; i++) {
                    if (this.rootIds[i] === this.nowTreeItem.id) {
                        isTreeRootNode = true;
                        break;
                    }
                }
            }
            if (this.rootCodes != null && this.rootCodes.length > 0) {
                for (let i = 0; i < this.rootCodes.length; i++) {
                    if (this.rootCodes[i] === this.nowTreeItem.sCode) {
                        isTreeRootNode = true;
                        break;
                    }
                }
            }
            // 如果是根节点则parentId为空
            if (isTreeRootNode) {
                parentItem = [{ parentId: null, id: this.nowTreeItem.id }];
            } else {
                parentItem = [{ parentId: this.nowTreeItem.parentId, id: this.nowTreeItem.id }];
            }
            // 添加节点回显到树形
            if (this.nowTreeItem.id != data.sParentId) {
                this.$message({ type: 'info', showClose: true, message: this.$t('pgMessage.SYSTEM_WILL_ADJUST_THE_LOCATION_AND_NAME'), offset: 60 });
                this.$refs.TdTree.initTree();
            } else {
                this.$refs.TdTree.editTreeNode(parentItem, 'add', val);
            }
            let queryVo = this.getParam(this.nowTreeItem);
            let _this = this;
            // 非admin时，添加完组织后向mq发送消息，权限监听mq队列添加组织权限，不能立即添加成功，这里延迟0.5秒查询
            setTimeout(function() {
                _this.queryData(queryVo, false);
            }, 500);
        },

        // 拖拽方法
        nodeDrop: function(dragNode, dropNode, dropType) {
            let queryParam = {
                orgId: dragNode.key
            };
            if (dropType === 'before') {
                queryParam.latterOrgId = dropNode.key;
            } else if (dropType === 'after') {
                queryParam.previousOrgId = dropNode.key;
            }
            orgApi.orgSort(JSON.stringify(queryParam), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ type: 'error', showClose: true, message: this.$t('common.OPERATION_FAIL') });
                        this.$log.error('/OrgManagerController/findTree', response.data.statusMessage);
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('common.OPERATION_FAIL') });
                    this.$log.error('/OrgManagerController/findTree', response);
                }
            });
        },

        // 导入
        btnImport: function() {
            if (this.nowTreeItem == null) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_BELONG_ORG'), type: 'warning' });
                return;
            }
            this.isImportVisible = true;
            this.orgId = this.nowTreeItem.orgId;
            this.importTitle = this.$t('pgCommon.UPLOAD_ORG_EXCEL');
        },

        // 导出
        btnExport: function() {
            if (this.nowTreeItem == null) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_ORG'), type: 'warning' });
                return;
            }
            this.exportLoadding = true;
            let param = new FormData();
            param.append('parentId', encodeURI(this.nowTreeItem.id));
            let responseType = 'arraybuffer';
            orgApi.exportOrg(param, responseType, response => {
                this.exportLoadding = false;
                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉子解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
            });
        },

        submit: function() {
            let _this = this;
            setTimeout(function() {
                // 刷新树形
                _this.$refs.TdTree.initTree();
                _this.onClickTab(this.nowTreeItem);
            }, 500);
        },

        // 添加组织dialog树形
        addOrgDialogClose: function() {
            this.addOrgAvailable = false;
            this.addPaneName = null;
            this.tabOptions = [];
        },

        // 编辑组织dialog树形
        modifyOrgDialogClose: function() {
            this.modifyOrgAvailable = false;
            this.modifyPaneName = null;
            this.tabOptions = [];
        },

        // 关闭上传页面
        importClose: function(data) {
            this.isImportVisible = false;
            if (!this.$util.isEmpty(data) && typeof data != 'function' && data.length > 0) {
                this.msgTitle = this.$t('pgCommon.IMPORT_RESULT');
                this.$refs.dialogMsg.setMessage(data);
                this.isMsgAvailable = true;
            }
        },

        // 关闭提示消息页面
        dlalogMsgClose: function() {
            this.isMsgAvailable = false;
        }
    }
};
</script>

<style>
.col-right {
    text-align: right;
    margin-top: 5px;
}
.margin-top20 {
    margin-top: 20px;
}
</style>
<style scoped>
.org-main {
    height: auto;
    padding-top: 10px;
    position: relative;
}
</style>
